import { forwardRef } from 'react';
import { useIntl } from 'react-intl';

import { styled } from 'styled-components';

import { StyledPasswordRevealIcon } from '../Icons';
import { TextField, TextFieldProps } from './TextField';

interface PasswordFieldProps extends TextFieldProps {
  showIcon?: boolean;
  showPassword: boolean;
  onRevealIconClick: React.MouseEventHandler<HTMLButtonElement>;
}

const ToggleButton = styled.button`
  all: unset;
  appearance: none;

  &:focus-visible {
    outline: 2px solid ${({ theme }) => theme.colors.focusOutline};
    outline-offset: 2px;
  }
`;

export const PasswordField = forwardRef<HTMLInputElement, PasswordFieldProps>(
  ({ onRevealIconClick, showIcon = true, showPassword, ...props }, ref) => {
    const intl = useIntl();
    const showPW = intl.formatMessage({
      id: 'membership_show_password',
    });
    const hidePW = intl.formatMessage({
      id: 'membership_hide_password',
    });

    return (
      <TextField
        {...props}
        ref={ref}
        icon={showIcon ? 'password' : undefined}
        aria-label="password"
        type={showPassword ? 'text' : 'password'}
      >
        <ToggleButton
          type="button"
          aria-label={showPassword ? showPW : hidePW}
          aria-pressed={showPassword}
          onClick={onRevealIconClick}
        >
          <StyledPasswordRevealIcon />
        </ToggleButton>
      </TextField>
    );
  },
);
